import { $myFetch } from "."

export const $getTerritoi = (): Promise<any> => {
  const myHeaders = new Headers()
  return $myFetch(
    "territoi",
    {
      headers: myHeaders
    },
    []
  )
}
